import { cn } from '@lib/cn'
import { ButtonHTMLAttributes, FC } from 'react'

type DirectionProps = {
  direction: 'prev' | 'next'
  variant?: 'light' | 'dark'
  className?: string
}

type Props = DirectionProps & ButtonHTMLAttributes<HTMLButtonElement>

const SliderNavButton: FC<Props> = ({ direction, className, variant = 'light', ...rest }) => {
  return (
    <button
      className={cn(
        'pointer-events-auto flex h-[50px] w-[50px] items-center justify-center rounded-full border-none bg-opacity-30 outline-none transition-colors duration-150',
        'disabled:cursor-not-allowed disabled:opacity-30',
        variant === 'dark' &&
          'bg-rolexGrey/30 text-rolexBrown hover:bg-rolexGrey/[0.15] focus:ring-2 focus:ring-rolexGreenAlt',
        variant === 'light' &&
          'bg-rolexDarkGrey/40 text-white hover:bg-rolexDarkGrey/50 focus:ring-2 focus:ring-rolexOceanGreen',
        className,
      )}
      aria-label={direction === 'prev' ? 'Previous slide' : 'Next slide'}
      {...rest}
    >
      <svg
        viewBox="0 0 15 15"
        fill="currentColor"
        className={cn('h-[14px] w-[14px]', direction === 'prev' && 'rotate-180')}
      >
        <path d="m5.52 0 7.91 7.5-7.91 7.5-1.95-1.95 5.83-5.55-5.83-5.55z"></path>
      </svg>
    </button>
  )
}

export default SliderNavButton
